import React from 'react'
import { Table, Typography } from 'antd';
import { getBizCashflow } from '../../../../../api/EmiPayments';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CURRENCY } from '../../../../../utils/ConstantData';
import { CurrencyFormatWithDecimal } from '../../../../../helper/CurrencyFormate';
import { TabsEnum } from '../../../../../utils/Enum/ReportTabsEnum';
import ZCard from '../../../../Card/Index';

const { Text } = Typography;

const BizCashflow = () => {
    const [cashFlow, setCashflow] = useState(null);
    const [quarterly, setQuarterly] = useState(null);
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
    const monthlyColumns= [
        {
            title: 'Month',
            dataIndex: 'month',
            key: 'month',
            width: 180,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}}>
                {value}
              </Typography.Text>
            ),
          },
          {
            title: `Total Inflow (${CURRENCY})`,
            dataIndex: 'inflow',
            key: 'inflow',
            width: 150,
            align: 'right',
            className: 'no-wrap-column',
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
                {CurrencyFormatWithDecimal(value, null, CURRENCY)}
              </Typography.Text>
            ),
          },
          {
            title: `Business Inflow (${CURRENCY})`,
            dataIndex: 'bizInflow',
            key: 'bizInflow',
            width: 150,
            align: 'right',
            className: 'no-wrap-column',
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
                {CurrencyFormatWithDecimal(value, null, CURRENCY)}
              </Typography.Text>
            ),
          },
          {
            title: '% Business Inflow',
            dataIndex: 'bizInflowPercentage',
            key: 'bizInflowPercentage',
            width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}}>
                {value}{value ? '%' : '-'}
              </Typography.Text>
            ),
          },
          {
            title: 'Business Inflow Txns',
            dataIndex: 'bizInflowTransactionCount',
            key: 'bizInflowTransactionCount',
            width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}}>
                {value}
              </Typography.Text>
            ),
          },
          {
            title: `Total Outflow (${CURRENCY})`,
            dataIndex: 'outflow',
            key: 'outflow',
            align: 'right',
            className: 'no-wrap-column',
            width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
                {CurrencyFormatWithDecimal(value, null, CURRENCY)}
              </Typography.Text>
            ),
          },
          {
            title: `Biz Outflow (${CURRENCY})`,
            dataIndex: 'bizOutflow',
            key: 'bizOutflow',
            align: 'right',
            className: 'no-wrap-column',
            width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
                {CurrencyFormatWithDecimal(value, null, CURRENCY)}
              </Typography.Text>
            ),
          },
          {
            title: '% Biz Outflow',
            dataIndex: 'bizOutflowPercentage',
            key: 'bizOutflowPercentage',
            width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}}>
                {value}{value ? '%' : '-'}
              </Typography.Text>
            ),
          },
          {
            title: 'Biz Outflow Txns',
            dataIndex: 'bizOutflowTransactionCount',
            key: 'bizOutflowTransactionCount',
            width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}}>
                {value}
              </Typography.Text>
            ),
          },
          {
            title: `Net Biz Cash Flow (${CURRENCY})`,
            dataIndex: 'bizCashFlow',
            key: 'bizCashFlow',
            align: 'right',
            className: 'no-wrap-column',
            width: 150,
            render: (value, record, index) => (
              <Typography.Text style={index >= (cashFlow?.length - 4) ? { fontWeight: 'bold' } : {}} {...(value < 0 ? { type: "danger" } : {})}>
                {CurrencyFormatWithDecimal(value, null, CURRENCY)}
              </Typography.Text>
            ),
          },
      ];
      

      useEffect(() => {

        const fetchData = async (accountId) => {
          try {
            console.log(selectedAccountId, 'id')

            let aggregate = accountId !== 'all'? false : true;
            let account_id = accountId !== 'all'? accountId : reportDetails?.report?.reportId;
            const response = await getBizCashflow(account_id, aggregate);
    
            setCashflow(response.monthly);
            setQuarterly(response.quarterly);
    
          } catch (error) {
    
            console.log("ERROR", error);
          }
        }
    
        if (selectedAccountId) {
          fetchData(selectedAccountId);
        }
      }, [selectedAccountId]);
      
  return (
    <div>
    <ZCard style={{marginBottom: '16px'}}>
    <Table
    dataSource={cashFlow}
    columns={monthlyColumns}
    pagination={false}
    scroll={{x : 1500}}
   />
  </ZCard>
  <ZCard>
    <ZCard.Title>Cumulative Quarterly Summary</ZCard.Title>
  <Table
    dataSource={quarterly}
    columns={monthlyColumns}
    pagination={false}
    showHeader={false}
    scroll={{x : 1500}}
  />
  </ZCard>
  </div>
);}

export default BizCashflow;